module.exports = __webpack_public_path__ + "static/media/shoe4.3c94b9d9.jpeg";